import BoxBlock from '../../containers/box/block';
import React from 'react';

const RootContainer = props => props.content.length ? <BoxBlock {...props}/> : null;

export default RootContainer;
